import * as React from "react";
import { MainLayout } from "../../components/Layout";
import LinkButton from "../../components/LinkButton";
import "./styles.scss";
import {
    CardPaymentPlan,
    PaymentPlanEnum,
    PaymentStatusObj,
    SubscriptionEnum
} from "../../generated/UserAPIAgent";
import { PAYMENT_PLANS } from "../../generated/lib-domain/paymentPlan";
import PlanList from "../../components/PlanList";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const cShipLogo = require("../../assets/icon/c-ship_logo.png").default;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const paappLogo = require("../../assets/icon/smakon-emb_logo.svg").default;

interface PaymentPlanProps {
    paymentStatus: PaymentStatusObj;
    isLoading: boolean;
    cardPaymentPlans: CardPaymentPlan[];
    onNavigateToPaymentPlanDetail: (paymentPlanId: PaymentPlanEnum) => boolean;
}

const PaymentPlan = (props: PaymentPlanProps) => {
    const planInfo = (paymentPlanId: PaymentPlanEnum) => {
        const cardPlan = PAYMENT_PLANS.find(
            (plan) => plan.id === paymentPlanId
        );
        const campaignDescription = props.cardPaymentPlans.find(
            (plan) => plan.paymentPlanId === paymentPlanId
        ).campaigns[0]?.description;
        const isLitePlan = paymentPlanId === PaymentPlanEnum.LITE_1M_CARD_1000;
        return (
            <>
                <div className="payment-plan__info-wrapper">
                    <div>
                        <img
                            src={isLitePlan ? paappLogo : cShipLogo}
                            width={40}
                            className={isLitePlan ? "paapp" : "cship"}
                        />
                    </div>
                    <div>
                        <div>{cardPlan.message.title}</div>
                        <div className="payment-plan__title">
                            {cardPlan.title}
                        </div>
                        <div className="payment-plan__amount">
                            月額{cardPlan.amount.toLocaleString("ja-JP")}円
                        </div>
                    </div>
                </div>
                {campaignDescription && campaignDescription !== "" && (
                    <div>
                        <div className="payment-plan__campaign-message">
                            <pre>{campaignDescription}</pre>
                        </div>
                    </div>
                )}
                <LinkButton
                    to="#"
                    onClick={() => {
                        props.onNavigateToPaymentPlanDetail(paymentPlanId);
                    }}
                    color="primary"
                    lines={2}
                >
                    {cardPlan.title}詳細
                </LinkButton>
            </>
        );
    };
    return (
        <MainLayout>
            <div className="payment-plan__page-title">有料会員プラン</div>
            <section className="payment-plan__description">
                {props.cardPaymentPlans &&
                    props.cardPaymentPlans.map((plan, index) => {
                        // NOTE 各プランの情報を表示
                        if (
                            plan.paymentPlanId ===
                                PaymentPlanEnum.LITE_1M_CARD_1000 &&
                            props.paymentStatus?.currentPaymentPlan
                                ?.subscription !== SubscriptionEnum.LITE
                        ) {
                            return (
                                <React.Fragment key={index}>
                                    {planInfo(
                                        PaymentPlanEnum.LITE_1M_CARD_1000
                                    )}
                                </React.Fragment>
                            );
                        }
                        if (
                            plan.paymentPlanId ===
                            PaymentPlanEnum.STANDARD_1M_CARD_9800
                        ) {
                            return (
                                <React.Fragment key={index}>
                                    {planInfo(
                                        PaymentPlanEnum.STANDARD_1M_CARD_9800
                                    )}
                                </React.Fragment>
                            );
                        }
                    })}
                <PlanList />
            </section>
            <section className="payment-plan__about">
                <h3>有料プランの購入について</h3>
                <p>購入日を1日目として30日後に自動更新され継続購入します。</p>
                <p>
                    次回更新日をご確認のうえ、自動更新を停止したい方は、「マイページ」＞「設定」＞「契約確認・変更」より手続きをお願いします。{" "}
                </p>
                <p>
                    停止した場合でも自動更新日までは、有料会員プランをご利用いただけます。
                </p>
            </section>
            <section>
                {props.cardPaymentPlans &&
                    props.cardPaymentPlans.map((plan) => {
                        if (
                            plan.paymentPlanId ===
                                PaymentPlanEnum.LITE_1M_CARD_1000 &&
                            props.paymentStatus?.currentPaymentPlan
                                ?.subscription !== SubscriptionEnum.LITE
                        ) {
                            return (
                                <LinkButton
                                    key={plan.paymentPlanId}
                                    to="#"
                                    onClick={() => {
                                        props.onNavigateToPaymentPlanDetail(
                                            PaymentPlanEnum.LITE_1M_CARD_1000
                                        );
                                    }}
                                    color="primary"
                                    lines={2}
                                >
                                    {
                                        PAYMENT_PLANS.find(
                                            (plan) =>
                                                plan.id ===
                                                PaymentPlanEnum.LITE_1M_CARD_1000
                                        ).title
                                    }
                                    詳細
                                </LinkButton>
                            );
                        }
                        if (
                            plan.paymentPlanId ===
                            PaymentPlanEnum.STANDARD_1M_CARD_9800
                        ) {
                            return (
                                <LinkButton
                                    key={plan.paymentPlanId}
                                    to="#"
                                    onClick={() => {
                                        props.onNavigateToPaymentPlanDetail(
                                            PaymentPlanEnum.STANDARD_1M_CARD_9800
                                        );
                                    }}
                                    color="primary"
                                    lines={2}
                                >
                                    {
                                        PAYMENT_PLANS.find(
                                            (plan) =>
                                                plan.id ===
                                                PaymentPlanEnum.STANDARD_1M_CARD_9800
                                        ).title
                                    }
                                    詳細
                                </LinkButton>
                            );
                        }
                    })}
            </section>
        </MainLayout>
    );
};

export default PaymentPlan;
